import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import SelectDropdown from "../../shared/components/SelectDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faChartLine } from "@fortawesome/free-solid-svg-icons";

const TotalConsignmentsCard = ({
  topN,
  setTopN,
  sortOrder,
  setSortOrder,
  chartType,
  setChartType,
  chartTypeOptions,
  topNOptions,
  sortOptions,
  isConsignmentLoading,
  consignmentError,
  filteredConsignments,
  chartPayload,
}) => (
  <div className="m-4 bg-gradient-to-br from-white to-gray-50 rounded-2xl border border-gray-200 shadow-lg overflow-hidden">
    {/* Header with gradient accent */}
    <div className="bg-gradient-to-r from-[#144677] to-[#1a5c99] p-6">
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 bg-white/10 rounded-lg backdrop-blur-sm">
          <FontAwesomeIcon icon={faChartLine} className="w-5 h-5 text-white" />
        </div>
        <h2 className="text-xl font-bold text-white">
          Total Consignments by Customer
        </h2>
      </div>
      <p className="text-sm text-white/80 pl-11">
        Showing ranked consignments for the active filters.
      </p>
    </div>

    {/* Controls Section */}
    <div className="p-6 bg-white border-b border-gray-100">
      <div className="flex flex-col gap-3 md:flex-row md:flex-wrap md:items-end">
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-semibold text-[#144677] mb-2">
            Top N
          </label>
          <SelectDropdown
            options={topNOptions}
            isMulti={false}
            isClearable={false}
            placeholder="Top 10"
            value={topNOptions.find((option) => option.value === topN) || null}
            onChange={(value) => setTopN(value?.value || 10)}
          />
        </div>
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-semibold text-[#144677] mb-2">
            Order
          </label>
          <SelectDropdown
            options={sortOptions}
            isMulti={false}
            isClearable={false}
            placeholder="Largest first"
            value={
              sortOptions.find((option) => option.value === sortOrder) || null
            }
            onChange={(value) => setSortOrder(value?.value || "desc")}
          />
        </div>
        <div className="flex-1 min-w-[200px]">
          <label className="block text-sm font-semibold text-[#144677] mb-2">
            Chart Type
          </label>
          <SelectDropdown
            options={chartTypeOptions}
            isMulti={false}
            isClearable={false}
            placeholder="Select chart type"
            value={
              chartTypeOptions.find((option) => option.value === chartType) ||
              null
            }
            onChange={(value) => setChartType(value?.value || "bar")}
          />
        </div>
        <button
          type="button"
          className="px-4 py-2.5 text-sm font-semibold rounded-lg bg-gradient-to-r from-[#144677] to-[#1a5c99] text-white hover:shadow-lg hover:scale-105 transition-all duration-200 flex items-center gap-2 justify-center"
          onClick={() =>
            ApexCharts.exec("consignments-chart", "dataURI").then(
              ({ imgURI }) => {
                const link = document.createElement("a");
                link.href = imgURI;
                link.download = "total-consignments.png";
                link.click();
              }
            )
          }
        >
          <FontAwesomeIcon icon={faDownload} className="w-4 h-4" />
          Export PNG
        </button>
      </div>
    </div>

    {/* Chart Section */}
    <div className="p-6">
      {isConsignmentLoading && (
        <div className="flex items-center justify-center py-20">
          <div className="flex flex-col items-center gap-3">
            <div className="w-12 h-12 border-4 border-[#144677] border-t-transparent rounded-full animate-spin"></div>
            <p className="text-sm font-medium text-gray-600">
              Loading consignments...
            </p>
          </div>
        </div>
      )}
      
      {consignmentError && (
        <div className="bg-red-50 border-l-4 border-[#FF6266] p-4 rounded-lg">
          <p className="text-sm font-medium text-red-800">{consignmentError}</p>
        </div>
      )}
      
      {!isConsignmentLoading &&
        !consignmentError &&
        filteredConsignments.length === 0 && (
          <div className="flex items-center justify-center py-20">
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FontAwesomeIcon icon={faChartLine} className="w-8 h-8 text-gray-400" />
              </div>
              <p className="text-sm font-medium text-gray-600">
                No data available for the selected filters.
              </p>
            </div>
          </div>
        )}
      
      {!isConsignmentLoading &&
        !consignmentError &&
        filteredConsignments.length > 0 && (
          <div className="bg-white rounded-lg">
            <Chart
              key={`${chartType}-${filteredConsignments.length}`}
              options={chartPayload.options}
              series={chartPayload.series}
              type={chartType}
              height={320}
            />
          </div>
        )}
    </div>
  </div>
);

export default TotalConsignmentsCard;
